// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ColumnLayout = ({ children, className }) => (
    <div className={classNames('ColumnLayout', className)}>{children}</div>
);

ColumnLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
};

export default ColumnLayout;
